import { updateExternalCalendarEvent as _updateExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  UpdateCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const updateExternalCalendarEvent = async (
  payload: UpdateCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _updateExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-update-event' },
    });
    throw error;
  }
};
